import React from 'react'
import Main from './comp/main'
// import Data from './data.json'
import './styles/App.css'
import { HashRouter } from 'react-router-dom'

export default function App() {
  return (
    <div>
      <HashRouter>
        <Main />
      </HashRouter>
    </div>
  );
}
